<template>
  <div class="popup-wrapper" :class="{ open: popupOpen }">
    <div class="va-row justify--center">
      <div class="flex md4 xs12">
        <div class="popup-container">
          <div class="speech-bubble">
            <i class="fa fa-times popup-close" @click="dismissPopup"></i>
            <div class="popup-content">
              <slot name="popup-content"></slot>
            </div>
          </div>
          <img
            class="inno-ask"
            :src="require('@/assets/images/inno-popup.png')"
            alt="ASK INNO"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  name: 'AppPopup',
  computed: {
    ...mapGetters(['popupOpen'])
  },
  methods: {
    dismissPopup() {
      this.$store.dispatch('togglePopup', false)
    }
  },
  watch: {
    popupOpen(val) {
      document.body.style.overflow = val ? 'hidden' : ''
    }
  }
}
</script>

<style lang="scss" scoped>
.popup-div {
  display: inline-block;
}
.popup-wrapper {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  width: 100%;
  height: 100%;
  z-index: 9997;
  background-color: rgba(255, 255, 255, 0.9);
  opacity: 0;
  visibility: hidden;
  transition: all 0.1s ease-in;
  .popup-container {
    position: relative;
    .inno-ask {
      position: absolute;
      right: -60px;
      transform: translateY(50px);
      transition: transform 0.3s ease-in-out;
    }
    .speech-bubble {
      position: relative;
      margin-top: 100px;
      background: #ffffff;
      border-radius: 1.8rem;
      padding: 30px 20px;
      box-shadow: 0 0 3px 0 rgba(0, 0, 0, 0.8);
      transform: translateY(-30px);
      opacity: 0;
      transition: all 0.3s ease-in-out;
      .popup-close {
        font-size: 1.4rem;
        color: $blue;
        position: absolute;
        left: 25px;
        top: 20px;
        &:hover {
          cursor: pointer;
          color: $darkblue;
        }
      }
      .popup-content {
        padding: 20px;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        height: 100%;
      }
    }
    .speech-bubble:after,
    .speech-bubble:before {
      top: 100%;
      left: 80%;
      border: solid transparent;
      content: ' ';
      height: 0;
      width: 0;
      position: absolute;
      pointer-events: none;
    }

    .speech-bubble:after {
      border-color: rgba(136, 183, 213, 0);
      border-top-color: #fff;
      border-width: 25px;
      margin-left: -25px;
    }
    .speech-bubble:before {
      border-color: rgba(194, 225, 245, 0);
      border-top-color: rgba(0, 0, 0, 0.2);
      border-width: 28px;
      margin-left: -28px;
    }
  }
  &.open {
    opacity: 1;
    visibility: visible;
    .popup-container {
      .inno-ask {
        transform: translateY(0);
      }
      .speech-bubble {
        transform: translateY(0);
        opacity: 1;
      }
    }
  }
}
</style>
